export default "__VITE_ASSET__Y2m6kG6t__"